import React, { useEffect, useRef, useState } from 'react';
import imgtop from '../../assets/img/top.png';

const announcements = [
  "Default announcement tab for new announcements and important updates - this is important so as to be within the line of sight of the user.",
  "Check out our latest features and updates on the dashboard.",
  "System maintenance scheduled for Sunday at 2 AM WAT.",
  "Don’t forget to verify your email to access all features."
];

function TopNav() {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  const fadeTimeoutRef = useRef(null);
  const switchTimeoutRef = useRef(null);

  useEffect(() => {
    if (isHovered) return; // Don't run timers if hovered

    fadeTimeoutRef.current = setTimeout(() => {
      setFade(false);
    }, 3500);

    switchTimeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % announcements.length);
      setFade(true);
    }, 4000);

    return () => {
      clearTimeout(fadeTimeoutRef.current);
      clearTimeout(switchTimeoutRef.current);
    };
  }, [index, isHovered]);

  return (
    <div className="top-bar"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* <p className={`topNav__fade ${fade ? 'fade-in' : 'fade-out'}`}>
        <img src={imgtop} className="announcement-img me-1" alt="" />
        {announcements[index]}
      </p> */}
    </div>
  );
}

export default TopNav;